import script from "./StudentReviewsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentReviewsPage.vue?vue&type=script&setup=true&lang=js"

import "./StudentReviewsPage.vue?vue&type=style&index=0&id=0d4b85d0&lang=css"

const __exports__ = script;

export default __exports__